import React from 'react';
import { motion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section className="w-full bg-lavender px-5 py-12 sm:py-20" data-id="element-33" data-mp="13cw12o9jckcj">
      <div className="mx-auto max-w-6xl" data-id="element-34" data-mp="yeuie4g0un1l">
        <div className="mx-auto max-w-2xl text-center" data-id="element-35" data-mp="ye1k7rv4p5v2">
          <span className="mb-5 inline-block rounded-full border border-aura/40 bg-card px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-aura" data-id="element-36" data-mp="tfq7989jef8m">
            🎁 También recibís 8 bonos digitales
          </span>
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-37" data-mp="kea2ph5el7cb">
            Todo lo que necesitás para convertir la intención de cuidarte en una experiencia más
            completa
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-38" data-mp="2esb7sjrjqqku">
            Ocho herramientas complementarias para organizar tus prácticas, explorar nuevos rituales
            y acompañar tu bienestar día a día.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-39" data-mp="vur9uvnx45jb">
          {bonos.map((bono, i) => <motion.article key={bono.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 4 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-aura/15 bg-card p-5" data-id="element-40" data-mp="hw1b7blg9xsu" data-mpi={i}>
              <div className="relative overflow-hidden rounded-xl bg-lavender/60" data-id="element-41" data-mp="10t2ix46e2c0h">
                {bono.coverImage ? <>
                    <img src={bono.coverImage} alt={`Portada del ${bono.badge.toLowerCase()}: ${bono.title}`} width="900" height="675" loading="lazy" decoding="async" className="block aspect-[4/3] w-full object-cover" data-id="element-42" data-mp="1tij9rxed1kul" />
                    <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gold/25" aria-hidden="true" data-id="element-43" data-mp="1y6sd3huq9ykm" />
                  </> : <div role="img" aria-label={`Espacio reservado para la portada del ${bono.badge.toLowerCase()}: ${bono.title}`} className="flex aspect-[4/3] w-full flex-col items-center justify-center gap-1.5 border border-dashed border-aura/30 px-3 text-center" data-id="element-44" data-mp="1p6vwm3ihs60n">
                    <ImageIcon className="h-5 w-5 text-aura" aria-hidden="true" data-id="element-45" data-mp="1afdarp2ybh9d" />
                    <span className="text-[10px] font-medium leading-snug text-plum/60" data-id="element-46" data-mp="15k7naltwhuj6">
                      Portada de {bono.title}
                    </span>
                  </div>}
              </div>

              <div className="mt-4 flex items-center justify-between gap-2" data-id="element-47" data-mp="3h5giabjpij37">
                <span className="text-[11px] font-bold uppercase tracking-wider text-aura" data-id="element-48" data-mp="3h7jkdty4w2oa">
                  {bono.badge}
                </span>
                <span className="shrink-0 rounded-full border border-gold/50 px-2 py-0.5 text-[10px] font-semibold text-plum/70" data-id="element-49" data-mp="3r3wc4ma4c6ge">
                  {bono.pages}
                </span>
              </div>

              <h3 className="mt-2 text-base font-bold leading-snug text-plum" data-id="element-50" data-mp="2ye7bia1bm8fb">{bono.title}</h3>
              <p className="mt-2 flex-1 text-[13px] leading-relaxed text-plum/75" data-id="element-51" data-mp="33ds8iewxk6pe">
                {bono.description}
              </p>
              <p className="mt-4 border-t border-gold/30 pt-3 text-[13px] font-medium leading-relaxed text-aura" data-id="element-52" data-mp="386d33innuntz">
                {bono.highlight}
              </p>
            </motion.article>)}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-base leading-relaxed text-plum sm:text-lg" data-id="element-53" data-mp="2fmejahu2sr8n">
          No son archivos agregados para aumentar el número de páginas. Cada bono cumple una{' '}
          <span className="font-semibold text-aura" data-id="element-54" data-mp="h4uirm8n211e">función concreta</span> dentro de tu experiencia
          de autocuidado.
        </p>

        <div className="mt-6 flex justify-center" data-id="element-55" data-mp="q73ps24p7ca1">
          <span className="rounded-full border border-gold/50 bg-card px-5 py-2.5 text-center text-sm font-medium text-plum" data-id="element-56" data-mp="q5960r55xq7j">
            8 bonos digitales · 48 páginas complementarias · Acceso de por vida
          </span>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-57" data-mp="1dxg6a1e0ehc8">
          <CTAButton label="QUIERO RECIBIR LA GUÍA Y LOS 8 BONOS" textClassName="text-[12px] tracking-tight sm:text-[15px] sm:tracking-normal" data-id="element-58" data-mp="1duu0o7aoibwn" />
          <p className="mt-3 text-center text-xs text-plum/60 sm:text-sm" data-id="element-59" data-mp="3fotaspc2en7r">
            Todo incluido dentro de Aura Viva 2026
          </p>
        </div>
      </div>
    </section>;
}